<div class="form-group" ngbDropdown #calendarPanel="ngbDropdown">
  <div class="input-group">
    <input type="text" class="form-control" [(ngModel)]="dateTxt" [placeholder]="mask" disabled />
    <div class="input-group-text calendar-button">
      <button class="btn btn-outline-secondary dropdown-toggle-split " ngbDropdownToggle>
        <div class="calendar" aria-hidden="true"></div>
      </button>
    </div>
  </div>
  <div ngbDropdownMenu class="dropdown-menu">
    <div class="row row__header">
      <button class="btn btn-link col-4" (click)="addYear($event, -1)">
        <span class="ngb-dp-navigation-arrow left"></span>
      </button>
      <button *ngIf="!isYearSelection" class="btn btn-link col-4" (click)="showYear($event, true)">{{ date.year }}</button>
      <button *ngIf="isYearSelection" class="btn btn-link col-4" (click)="showYear($event, false)">{{ incr + 1 }}-{{ incr + 10 }}</button>
      <button class="btn btn-link col-4" (click)="addYear($event, +1)">
        <span class="ngb-dp-navigation-arrow right"></span>
      </button>
    </div>
    <div class="row">
      <div
        *ngFor="let month of months; let i = index; let first = first; let last = last"
        [ngClass]="{ disabled: !isSelectedDateGreaterOrEqualThanMinDate(i + 1) }"
        class="col-4"
        (click)="selectYearMonth($event, i)"
      >
        <div
          [ngClass]="{
            select: !isYearSelection ? i + 1 === date.month : i + incr === date.year,
            outrange: isYearSelection && (first || last)
          }"
          class="card-body"
        >
          <span *ngIf="!isYearSelection" translate>{{ month }}</span>
          <span *ngIf="isYearSelection">{{ i + incr }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
